export default __webpack_public_path__ + "static/media/error-404.3f7cbd6f.png";